import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';
import { HttpClient } from '@angular/common/http';
import { Capacitor } from '@capacitor/core';
import { MicrosoftAuth } from './microsoft-auth.android';

import {
  AuthProvider,
  UsuarioAutenticado
} from '../../models/auth.models';

import { AuthProviderService } from './auth-provider.interface';

@Injectable({
  providedIn: 'root'
})
export class MicrosoftAuthProviderService
  implements AuthProviderService {

  readonly provider: AuthProvider = 'microsoft';
  private usuarioAndroid?: UsuarioAutenticado;

  constructor(
    private msalService: MsalService,
    private http: HttpClient
  ) {}

  async handleRedirect(): Promise<UsuarioAutenticado | null> {
    const result = await this.msalService
        .handleRedirectObservable()
        .toPromise();

    if (!result?.account) {
        return null;
    }

    this.msalService.instance.setActiveAccount(result.account);

    return this.getUsuario();
  }

  async login(): Promise<UsuarioAutenticado | null> {

    if (Capacitor.getPlatform() === 'android') {

    const resultado = await MicrosoftAuth.login();

    this.usuarioAndroid = {
        id: resultado.id ?? '',
        nome: resultado.name ?? resultado.username ?? '',
        email: resultado.username ?? '',
        foto: resultado.foto,
        provider: 'microsoft'
    };

    console.log(
        'MICROSOFT ANDROID:',
        JSON.stringify({
            nome: this.usuarioAndroid.nome,
            temFoto: !!this.usuarioAndroid.foto,
            tamanhoFoto: this.usuarioAndroid.foto?.length ?? 0
        })
    );

    return this.usuarioAndroid;
}

    await this.msalService.loginRedirect({
      scopes: [
        'openid',
        'profile',
        'email',
        'User.Read'
      ]
    });

    return null;
  }

  async logout(): Promise<void> {
    await this.msalService.logoutRedirect();
  }

  async getUsuario(): Promise<UsuarioAutenticado | null> {

    if (Capacitor.getPlatform() === 'android') {
        return this.usuarioAndroid ?? null;
    }

    const account = this.getAccount();

    if (!account) {
      return null;
    }

    const foto = await this.obterFoto();

    return {
      id: account.localAccountId,
      nome: account.name ?? account.username,
      email: account.username,
      foto,
      provider: 'microsoft'
    };
  }

  async getToken(scopes: string[] = []): Promise<string | null> {

    const account = this.getAccount();

    if (!account) {
      return null;
    }

    const result = await this.msalService
      .acquireTokenSilent({
        scopes,
        account
      })
      .toPromise();

    return result?.accessToken ?? null;
  }

  async estaAutenticado(): Promise<boolean> {
    if (Capacitor.getPlatform() === 'android') {
        return this.usuarioAndroid !== undefined;
    }

    return this.getAccount() !== null;
  }

  private getAccount(): AccountInfo | null {

    return this.msalService.instance.getActiveAccount()
      ?? this.msalService.instance.getAllAccounts()[0]
      ?? null;
  }

  private async obterFoto(): Promise<string | undefined> {

    try {

        const token = await this.getToken(['User.Read']);

        if (!token) {
        return undefined;
        }

        const foto = await this.http.get(
        'https://graph.microsoft.com/v1.0/me/photos/48x48/$value',
        {
            headers: {
            Authorization: `Bearer ${token}`
            },
            responseType: 'blob'
        }
        ).toPromise();

        if (!foto) {
        return undefined;
        }

        return URL.createObjectURL(foto);

    } catch (error) {

        console.log(
        'Não foi possível obter a foto do Microsoft Graph.',
        error
        );

        return undefined;
    }
    }
}